// generated file, if you want to edit this file manually change the word "generated" to "manual"

import { isVariantEnabled, makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForContent = makeThemedStyles('Content', () => ({
  Content: {
    margin: '10px',
    padding: '10px',
    borderRadius: '5px',
    background: 'none'
  },

  marginSmall: {
    margin: '6px',
    padding: '0px'
  },
  contentArea: {
    margin: '0px',
    padding: '0px',
    marginTop: '20px'
  }
}));

type ElementProps = React.ComponentProps<React.HTMLFactory<HTMLElementTagNameMap['div']>>;

export const Content: React.FunctionComponent<ElementProps> = (props: ElementProps) => {
  const styles = useStylesForContent();

  /* eslint-disable */
  return (
    <div
      {...props}
      style={{ ...(props?.style || {}), ...{} }}
      className={clsx(styles.Content, {
        [styles.marginSmall]: isVariantEnabled(props, 'marginSmall'),
        [styles.contentArea]: isVariantEnabled(props, 'contentArea')
      })}
    >
      {props?.children}
    </div>
  );
};
export default Content;
